module.exports = __webpack_public_path__ + "static/media/outlet_type.7947e8ab.svg";